'use strict';

class timeTrackingService {
  constructor($http) {
    this.$http = $http;
  }

  getProjects() {
    return this.$http.get(`/time-tracking/projects/`);
  }

  getProject(number) {
    return this.$http.get(`/time-tracking/projects/` + number);
  }

  saveProject(data) {
    return this.$http.post(`/time-tracking/projects/`, data);
  }

  saveInvoiceData(data) {
    return this.$http.post(`/time-tracking/reports/`, data);
  }

  downloadXls(entries) {
    let e = '';
    let cnt = 0;
    entries.forEach((en) => {
      if (en === entries.length - 1) {
        e += en + ',';
      } else {
        e += en;
      }
    });
    // return this.$http.get(`/time-tracking/reports/xls`, {
    return this.$http.get(`/time-tracking/reports/xls?entries=` + entries.toString(), {
      responseType: 'arraybuffer'
    }).then((resp) => {
      if (resp) {
        const filename = resp.headers()['content-disposition'] ? resp.headers()['content-disposition'].match(/filename="(.+)"/)[1] : 'rapport';
        const contentType = resp.headers()['content-type'];

        saveAs(new Blob([resp.data], {
          type: contentType
        }), filename);
      }
    });
  }

  updateProject(number, params) {
    return this.$http.put(`/time-tracking/projects/${number}`, params);
  }

  deleteProject(number) {
    return this.$http.delete(`/time-tracking/projects/${number}`);
  }

  saveEntry(data) {
    return this.$http.post(`/time-tracking/entries/`, data);
  }

  updateEntry(number, params) {
    return this.$http.put(`/time-tracking/entries/${number}`, params);
  }

  deleteEntry(number) {
    return this.$http.delete(`/time-tracking/entries/${number}`);
  }

  getEntries(date) {
    return this.$http.get(`/time-tracking/entries/?date=${date}`);
  }

  getReport(dateFrom, dateTo) {
    return this.$http.get(`/time-tracking/reports/?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  }

  getEntry(number) {
    return this.$http.get(`/time-tracking/entries/` + number);
  }

}

timeTrackingService.$inject = ['$http'];

angular
  .module('SendRegning')
  .service('timeTrackingService', timeTrackingService);
